'use client';

import React, { useMemo, useState, useCallback } from 'react';
import Head from 'next/head';
import { CustomCheckbox } from '../components/forms/CustomCheckbox';

const LEAD_ENDPOINT = `${process.env.NEXT_PUBLIC_STRAPI_API_URL}/api/inquiries`;

type Industry = 'IT-сфера и Интернет' | 'Агрономия' | 'Администрация ' | 'Финтех' | 'Культура и искусство ' | 'Педагогика' | 'Строительство и ремонт' | 'Сфера обслуживания' | 'Сфера промышленности' | 'Торговля и маркетинг' | 'Транспорт и логистика' | 'Уход и здоровье';
type Size = 'Малый бизнес' | 'Средний бизнес' | 'Крупный бизнес';
type Model = 'Подбор персонала' | 'Аутсорс' | 'Аутстафф';

type Client = { id: string; name: string; industry: Industry; size: Size; model: Model; since: string; logo: string; };
type CaseItem = { id: string; client: string; title: string; kpIs: [string, string][]; cover: string; excerpt: string; };
type Review = { id: string; author: string; text: string; };

interface InquiryData {
  name: string;
  email: string;
  company: string;
  source: string;
  formName: string;
}

const CLIENTS: Client[] = [
  { id: 'c1', name: 'ГиперМаркет', industry: 'Торговля и маркетинг', size: 'Крупный бизнес', model: 'Подбор персонала', since: '2024-11-01', logo: 'https://placehold.co/280x120?text=ГиперМаркет' },

  { id: 'c2', name: 'ОнлайнМолл', industry: 'IT-сфера и Интернет', size: 'Средний бизнес', model: 'Аутсорс', since: '2025-04-15', logo: 'https://placehold.co/280x120?text=ОнлайнМолл' },

  { id: 'c3', name: 'ЛогистПро', industry: 'Транспорт и логистика', size: 'Крупный бизнес', model: 'Аутстафф', since: '2025-02-10', logo: 'https://placehold.co/280x120?text=ЛогистПро' },

  { id: 'c4', name: 'ФинТехСофт', industry: 'IT-сфера и Интернет', size: 'Средний бизнес', model: 'Подбор персонала', since: '2024-09-05', logo: 'https://placehold.co/280x120?text=ФинТехСофт' },

  { id: 'c5', name: 'СервисХелп', industry: 'Сфера обслуживания', size: 'Малый бизнес', model: 'Аутстафф', since: '2025-05-12', logo: 'https://placehold.co/280x120?text=СервисХелп' },

  { id: 'c6', name: 'МегаМаркет', industry: 'Торговля и маркетинг', size: 'Крупный бизнес', model: 'Подбор персонала', since: '2025-01-20', logo: 'https://placehold.co/280x120?text=МегаМаркет' },

  { id: 'c7', name: 'eBoxRu', industry: 'IT-сфера и Интернет', size: 'Малый бизнес', model: 'Аутсорс', since: '2025-03-02', logo: 'https://placehold.co/280x120?text=eBoxRu' },

  { id: 'c8', name: 'КаргоЭксперт', industry: 'Транспорт и логистика', size: 'Средний бизнес', model: 'Аутстафф', since: '2024-12-18', logo: 'https://placehold.co/280x120?text=КаргоЭксперт' },

  { id: 'c9', name: 'ФинДом', industry: 'IT-сфера и Интернет', size: 'Крупный бизнес', model: 'Подбор персонала', since: '2025-06-01', logo: 'https://placehold.co/280x120?text=ФинДом' },

  { id: 'c10', name: 'Поддержка24', industry: 'Сфера обслуживания', size: 'Средний бизнес', model: 'Аутсорс', since: '2025-07-10', logo: 'https://placehold.co/280x120?text=Поддержка24' },
];


const CASES: CaseItem[] = [
  { id: 'k1', client: 'FastMart', title: 'RPO для национального ритейла', kpIs: [['Закрытий/кв', '180+'], ['CPH', '-19%'], ['Явка', '96%']], cover: 'https://placehold.co/800x480?text=Case+FastMart', excerpt: 'Мультиканальная воронка, BI-контроль, SLA по скоростям.' },
  { id: 'k2', client: 'Shoply', title: 'Сезонный аутсорс под пиковый спрос', kpIs: [['TTH', '-22%'], ['Time-to-Interview', '48ч'], ['NPS Hiring', '+23%']], cover: 'https://placehold.co/800x480?text=Case+Shoply', excerpt: 'Экспресс-масштабирование команды на квартал без потери качества.' },
  { id: 'k3', client: 'QuickShip', title: 'Аутстафф L1/L2 поддержки', kpIs: [['SLA ответов', '95%'], ['Окупаемость', '3 мес'], ['QA интервью', '9.2/10']], cover: 'https://placehold.co/800x480?text=Case+QuickShip', excerpt: 'Набор, обучение и QA-оценка операторов службы поддержки.' },
];

const REVIEWS: Review[] = [
  { id: 'r1', author: 'Айшат К., HRD FastMart', text: 'С INTERIM получили предсказуемую воронку и прозрачные KPI. Запуск — за 2 недели.' },
  { id: 'r2', author: 'Ибрагим П., COO QuickShip', text: 'Оперативно укомплектовали L1/L2 и ввели QA. SLA держится стабильно.' },
  { id: 'r3', author: 'Марьям С., Head of Talent Shoply', text: 'Пик прошли без сбоев: Time-to-Hire снизили, качество — выросло.' },
];

function Card({ children, className }: { children: React.ReactNode; className?: string }) {
  return <article className={`rounded-2xl ${className || ''}`} style={{ background: 'rgba(255,255,255,.08)', backdropFilter: 'blur(8px)' }}>{children}</article>;
}

function Chip({ href, children }: { href: string; children: React.ReactNode }) {
  return <a href={href} className="px-3 py-1 rounded-full hover:bg-white/25 text-sm" style={{ background: 'rgba(255,255,255,.14)' }}>{children}</a>;
}

const LeadForm: React.FC = () => {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [company, setCompany] = useState('');
  const [interest, setInterest] = useState('Интересует: RPO');
  const [isConsentChecked, setIsConsentChecked] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [status, setStatus] = useState<'idle' | 'success' | 'error'>('idle');
  const [message, setMessage] = useState('');

  const resetForm = useCallback(() => {
    setName('');
    setEmail('');
    setCompany('');
    setInterest('Интересует: RPO');
    setIsConsentChecked(false);
    setStatus('success');
  }, []);

  const handleSubmit = useCallback(async (e: React.FormEvent) => {
    e.preventDefault();

    if (!isConsentChecked) {
      setStatus('error');
      setMessage('Пожалуйста, согласитесь с обработкой персональных данных.');
      return;
    }

    if (isSubmitting || status === 'success') return;

    setIsSubmitting(true);
    setStatus('idle');
    setMessage('');

    const leadData: InquiryData = {
      name: name.trim(),
      email: email.trim(),
      company: company.trim(),
      source: 'Clients Page CTA',
      formName: 'Клиенты'
    };

    try {
      const response = await fetch(LEAD_ENDPOINT, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          data: leadData
        }),
      });

      if (response.ok) {
        setMessage('Запрос успешно отправлен! Скоро свяжемся с вами.');
        resetForm();
      } else {
        const errorData = await response.json().catch(() => ({}));
        const errorMessage = errorData.error?.message || response.statusText || 'Неизвестная ошибка сервера.';
        setStatus('error');
        setMessage(`Ошибка отправки в Strapi: ${errorMessage}`);
      }
    } catch (error) {
      console.error('Network or other error:', error);
      setStatus('error');
      setMessage('Произошла ошибка сети. Проверьте подключение или попробуйте позже.');
    } finally {
      setIsSubmitting(false);
    }
  }, [name, email, company, interest, isSubmitting, status, isConsentChecked, resetForm]);

  const handleConsentChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setIsConsentChecked(e.target.checked);
    if (e.target.checked && status === 'error' && message.includes('согласитесь с обработкой')) {
      setStatus('idle');
      setMessage('');
    }
  };

  const buttonText = isSubmitting
    ? 'Отправка...'
    : status === 'success'
      ? 'Успешно'
      : 'Отправить';

  const buttonStyle = status === 'success'
    ? { background: '#22C55E', color: 'white' }
    : { background: '#FFC300', color: '#102a43' };

  return (
    <>
      <form className="grid gap-3" onSubmit={handleSubmit}>
        <input
          className="rounded-xl px-4 py-3 text-gray-900"
          placeholder="Имя*"
          value={name}
          onChange={(e) => { setName(e.target.value); setStatus('idle'); setMessage(''); }}
          required
          disabled={status === 'success'}
        />
        <input
          className="rounded-xl px-4 py-3 text-gray-900"
          placeholder="E-mail*"
          type="email"
          value={email}
          onChange={(e) => { setEmail(e.target.value); setStatus('idle'); setMessage(''); }}
          required
          disabled={status === 'success'}
        />
        <input
          className="rounded-xl px-4 py-3 text-gray-900"
          placeholder="Компания"
          value={company}
          onChange={(e) => { setCompany(e.target.value); setStatus('idle'); setMessage(''); }}
          disabled={status === 'success'}
        />
        <select
          className="rounded-xl px-4 py-3 text-gray-900"
          value={interest}
          onChange={(e) => { setInterest(e.target.value); setStatus('idle'); setMessage(''); }}
          disabled={status === 'success'}
        >
          {['Интересует: RPO', 'Аутсорс', 'Аутстафф', 'Консалтинг'].map(v => <option key={v}>{v}</option>)}
        </select>
        <CustomCheckbox
          name="consent"
          isChecked={isConsentChecked}
          onChange={handleConsentChange}
          link="/privacy"
          textColorClass="text-gray-400"
          linkColorClass="text-[#FF7C22]"
        />
        <button
          className="px-4 py-3 rounded-xl font-semibold"
          type="submit"
          style={buttonStyle}
          disabled={isSubmitting}
        >
          {buttonText}
        </button>
      </form>
      {message && (
        <p className={`mt-2 text-sm ${status === 'error' ? 'text-red-400' : 'text-green-400'}`}>
          {message}
        </p>
      )}
    </>
  );
};

export default function ClientsPage() {
  const [q, setQ] = useState('');
  const [industry, setIndustry] = useState<Industry | ''>('');
  const [size, setSize] = useState<Size | ''>('');
  const [model, setModel] = useState<Model | ''>('');
  const [sort, setSort] = useState<'all' | 'name' | 'recent'>('all');

  const items = useMemo(() => {
    let arr = CLIENTS.filter(c => {
      const hay = (c.name + ' ' + c.industry + ' ' + c.model).toLowerCase();
      return (!q || hay.includes(q.trim().toLowerCase())) &&
        (!industry || c.industry === industry) &&
        (!size || c.size === size) &&
        (!model || c.model === model);
    });
    if (sort === 'name') arr.sort((a, b) => a.name.localeCompare(b.name, 'ru'));
    if (sort === 'recent') arr.sort((a, b) => +new Date(b.since) - +new Date(a.since));
    return arr;
  }, [q, industry, size, model, sort]);

  return (
    <div className="bg-gradient-to-br from-blue-900 to-blue-800 text-gray-100 min-h-screen">
      <Head>
        <title>INTERIM — Клиенты и Кейсы</title>
      </Head>
      <header className="px-6 pt-32 pb-16 md:pt-40 md:pb-20"
        style={{ background: 'linear-gradient(rgba(0,0,0,.45), rgba(0,0,0,.25)), radial-gradient(1200px 600px at 70% -10%, rgba(255,255,255,.08), transparent)' }}>
        <div className="max-w-7xl mx-auto">
          <nav className="mb-6 flex flex-wrap gap-3 text-sm">
            <Chip href="#logos">Логотипы</Chip>
            <Chip href="#cases">Кейсы</Chip>
            <Chip href="#reviews">Отзывы</Chip>
            <Chip href="#faq">FAQ</Chip>
          </nav>

          <h1 className="text-4xl md:text-6xl font-extrabold mb-4">Наши клиенты</h1>
          <p className="max-w-3xl text-lg md:text-xl text-gray-200">
            Ритейл, электронная коммерция, логистика, финтех и поддержка: массовый подбор, RPO, аутсорс и аутстафф.
          </p>

          <div className="mt-8 flex flex-wrap gap-4">
            <a href="#cases" className="px-4 py-3 rounded-xl font-semibold" style={{ background: 'rgba(255,255,255,.1)' }}>Смотреть кейсы</a>
            <a href="#cta" className="px-4 py-3 rounded-xl font-semibold" style={{ background: '#FFC300', color: '#102a43' }}>Обсудить задачу</a>
          </div>
        </div>
      </header>

      <main className="px-6 py-12 md:py-16 max-w-7xl mx-auto space-y-16">

        <section className="grid gap-4 md:grid-cols-4">
          {[
            ['180+', 'закрытий/кв. у крупнейших клиентов'],
            ['96%', 'явка кандидатов на интервью'],
            ['-19%', 'CPH в реальных кейсах'],
            ['7', 'каналов привлечения воронки'],
          ].map(([n, t]) => (
            <div key={t as string} className="rounded-2xl p-6" style={{ background: 'linear-gradient(180deg, rgba(255,255,255,.12), rgba(255,255,255,.04))' }}>
              <div className="text-4xl font-extrabold">{n}</div>
              <div className="text-sm text-gray-200">{t}</div>
            </div>
          ))}
        </section>

        <section id="logos" aria-label="Логотипы клиентов" className="scroll-mt-32">
          <div className="flex items-end justify-between gap-4 flex-wrap">
            <h2 className="text-3xl md:text-4xl font-bold">Клиенты и партнёры</h2>
            <span className="text-sm text-gray-300">Компаний: {items.length}</span>
          </div>

          <div className="mt-4 grid gap-3 md:grid-cols-6">
            <input value={q} onChange={e => setQ(e.target.value)} className="rounded-xl px-4 py-3 text-gray-900 md:col-span-2" placeholder="Поиск по названию…" />
            <select value={industry} onChange={e => setIndustry(e.target.value as Industry | '')} className="rounded-xl px-4 py-3 text-gray-900">
              <option value="">Отрасль: все</option>
              {(['IT-сфера и Интернет', 'Агрономия ', 'Администрация ', 'Культура и искусство ', 'Педагогика', 'Строительство и ремонт', 'Сфера обслуживания', 'Сфера промышленности', 'Торговля и маркетинг', 'Транспорт и логистика', 'Уход и здоровье'] as Industry[]).map(v => <option key={v}>{v}</option>)}
            </select>
            <select
              value={size}
              onChange={e => setSize(e.target.value as Size | '')}
              className="rounded-xl px-4 py-3 text-gray-900"
            >
              <option value="">Масштаб: все</option>
              {[
                { value: 'SMB', label: 'Малый бизнес' },
                { value: 'Mid', label: 'Средний бизнес' },
                { value: 'Enterprise', label: 'Крупный бизнес' }
              ].map(v => (
                <option key={v.value} value={v.value}>
                  {v.label}
                </option>
              ))}
            </select>

            <select value={model} onChange={e => setModel(e.target.value as Model | '')} className="rounded-xl px-4 py-3 text-gray-900">
              <option value="">Модель: все</option>
              {(['Подбор персонала', 'Аутсорс', 'Аутстафф'] as Model[]).map(v => <option key={v}>{v}</option>)}
            </select>
            <select
              value={sort}
              onChange={e => setSort(e.target.value as 'all' | 'name' | 'recent')}
              className="rounded-xl px-4 py-3 text-gray-900"
            >
              <option value="all">Сортировать: все</option>
              <option value="name">по названию</option>
              <option value="recent">по давности сотрудничества</option>
            </select>

          </div>

          <div className="mt-6 grid gap-4 grid-cols-2 md:grid-cols-3 lg:grid-cols-5">
            {items.map(c => (
              <Card key={c.id} className="p-4 flex flex-col items-center text-center">
                <img className="w-40 h-16 object-contain" style={{ filter: 'grayscale(1) opacity(.85)' }} src={c.logo} alt={c.name}
                  onError={({ currentTarget }) => { (currentTarget as HTMLImageElement).src = 'https://placehold.co/280x120?text=Logo'; }} />
                <div className="mt-3 font-semibold">{c.name}</div>
                <div className="mt-1 text-xs flex flex-wrap gap-2">
                  {[c.industry, c.size, c.model].map(t => <span key={t} className="px-2.5 py-1 rounded bg-white/15">{t}</span>)}
                </div>
              </Card>
            ))}
          </div>

          {items.length === 0 && <p className="text-gray-300 mt-4">Ничего не найдено — измените фильтры.</p>}
        </section>

        <section id="cases" aria-label="Кейсы" className="space-y-4 scroll-mt-32">
          <h2 className="text-3xl md:text-4xl font-bold">Кейсы и результаты</h2>
          <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-3">
            {CASES.map(k => (
              <Card key={k.id} className="overflow-hidden flex flex-col">
                <img src={k.cover} className="w-full h-40 object-cover" alt="" />
                <div className="p-5">
                  <div className="text-xs flex flex-wrap gap-2 mb-1">
                    <span className="px-2.5 py-1 rounded bg-white/15">{k.client}</span>
                    <span className="px-2.5 py-1 rounded bg-white/15">Кейс</span>
                  </div>
                  <h3 className="text-xl font-semibold">{k.title}</h3>
                  <p className="text-sm text-gray-200 mt-2">{k.excerpt}</p>
                  <div className="mt-3 grid grid-cols-3 gap-2 text-center">
                    {k.kpIs.map(([kpi, val]) => (
                      <div key={kpi} className="rounded-xl p-3" style={{ background: 'linear-gradient(180deg, rgba(255,255,255,.12), rgba(255,255,255,.04))' }}>
                        <div className="text-lg font-bold">{val}</div>
                        <div className="text-xs text-gray-200">{kpi}</div>
                      </div>
                    ))}
                  </div>
                  <div className="mt-4"><a className="px-3 py-2 rounded-xl font-semibold" style={{ background: 'rgba(255,255,255,.1)' }} href="#cta">Обсудить похожее</a></div>
                </div>
              </Card>
            ))}
          </div>
        </section>

        <section id="reviews" aria-label="Отзывы" className="scroll-mt-32">
          <h2 className="text-3xl md:text-4xl font-bold mb-4">Отзывы клиентов</h2>
          <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-3">
            {REVIEWS.map(r => (
              <Card key={r.id} className="p-5">
                <blockquote className="text-lg">“{r.text}”</blockquote>
                <figcaption className="mt-3 text-sm text-gray-300">— {r.author}</figcaption>
              </Card>
            ))}
          </div>
        </section>

        <section id="cta" className="rounded-2xl p-6 grid gap-4 md:grid-cols-3 scroll-mt-32" style={{ background: 'rgba(255,255,255,.08)' }}>
          <div className="md:col-span-2">
            <h3 className="text-2xl font-bold">Готовы обсудить вашу задачу?</h3>
            <p className="text-sm text-gray-200 mt-1">Подберём модель работы, показатели эффективности и стандарты обслуживания под ваш поток кандидатов.</p>
          </div>
          <LeadForm />
        </section>

        <section id="faq" className="scroll-mt-32">
          <h2 className="text-3xl md:text-4xl font-bold mb-6">FAQ</h2>
          <div className="space-y-3">
            {[
              ['Как быстро старт?', 'Обычно за 14 дней: согласуем бриф, показатели эффективности (KPI), сроки и стандарты работы (SLA), подключаем каналы и настраиваем отчётность в системе бизнес-аналитики.'],
              ['Как контролируете качество?', 'Стандарты обслуживания, оценки качества работы, показатели явки, время закрытия вакансий и еженедельные отчёты.'],
            ].map(([q, a]) => (
              <details key={q as string} className="rounded-xl p-4" style={{ background: 'rgba(255,255,255,.08)' }}>
                <summary className="cursor-pointer font-semibold">{q as string}</summary>
                <p className="mt-2 text-sm text-gray-200">{a as string}</p>
              </details>
            ))}
          </div>
        </section>
      </main>
    </div>
  );
}